import * as React from "react";
import { styled } from "@mui/system";
import MUITab from "@mui/material/Tab";
import Stack from "@vapor/react-material/Stack";
import { TabProps as TabPropsMUI } from "@mui/material/Tab";
export interface ExtendedTabProps extends TabPropsMUI {
  /**
   * If want to change variant of the component.
   * @default standard
   */
  variant?: "activeStep" | "standard";
  /**
   *If want to add an element to the right. Ex: Badge.
   */
  contentRight?: React.ReactElement;

  /**
   *If want to add an element to the left. Ex: Icon.
   */
  contentLeft?: React.ReactElement;
}

export const ExtendedTab = styled(
  React.forwardRef(
    (
      { contentLeft, contentRight, label, ...props }: ExtendedTabProps,
      ref: any
    ) => {
      return (
        <MUITab
          ref={ref}
          {...props}
          label={
            <Stack direction="row" alignItems="center" spacing={1.25}>
              {contentLeft || null}
              <Stack>{label}</Stack>
              {contentRight || null}
            </Stack>
          }
        />
      );
    }
  ),
  {
    name: "ExtendedTab",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "variant",
    overridesResolver: (props, styles) => []
  }
)<ExtendedTabProps>(({ theme, variant }) => ({
  "&.MuiTab-root": {
    ...theme.typography["titleMedium"],
    color: theme.palette.primary.textSubduedColor,
    fontWeight: 600,
    paddingLeft: 24,
    paddingRight: variant === "activeStep" ? 48 : 24,
    borderBottom: "4px solid transparent",
    clipPath:
      variant === "activeStep" &&
      "polygon(0% 0%, calc(100% - 24px) 0%, 100% 50%, calc(100% - 24px) 100%, 0% 100%)",
    opacity: "1"
  },
  "&.MuiTab-root:hover": {
    ...theme.typography["titleMedium"],
    background: theme.palette.primary.interactiveDefault,
    color: theme.palette.primary.baseWhiteColor,
    fontWeight: 600
  },
  "&.MuiTab-root.Mui-selected": {
    ...theme.typography["titleMedium"],
    color: theme.palette.primary.primary60Color,
    background: theme.palette.primary.background,
    borderBottom: "4px solid " + theme.palette.primary.borderActive
  },
  "&.MuiTab-root.Mui-disabled": {
    cursor: "not-allowed",
    pointerEvents: "all !important",
    color: theme.palette.primary.textDisabledColor
  },
  "&.MuiTab-root.Mui-disabled:hover": {
    background: "transparent"
  },
  "&.MuiTab-root div .svg-inline--fa": {
    fontSize: 16
  },
  "&.MuiTab-root div .MuiBadge-root .MuiBadge-badge": {
    position: "relative",
    top: 11,
    right: 10
  }
}));
